import { SVGProps } from 'react';

const CircleGauge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.6 2.7a10 10 0 1 0 5.7 5.7m-7.9 2.2L19 5m-5 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default CircleGauge;
